<template>
  <select v-model="lang">
    <option :value="locale.code" v-for="locale in locales" :key="locale.code">
      {{locale.name}}
    </option>
  </select>

</template>

<script>
import { getSupportedLocales } from "@/services/i18n/supportedLocals"
export default {
  data: () => ({ locales: getSupportedLocales() }),
  computed: {
    lang: {
      get: function() {
        return this.$store.getters.getUserSelectedLocale
      },
      set: function(newVal) {
        this.$store.dispatch('changeLocale', newVal)
      }
    }
  }
}
</script>

<style scoped>

</style>